export const ExchangeMailHowItWorks: React.FC = () => {
  return (
    <div>
      Connect your accounts to easily draft and send emails through your on-premise Exchange account. Leverage client emails for meeting prep and insights,
      capture more tasks, and get answers to client-related questions in seconds from your inbox.
    </div>
  )
}
